export function keyExtractorId(item: { id: string }): string {
  return item.id;
}
